import { render } from "./colorButton.vue?vue&type=template&id=5380ca4a&scoped=true&ts=true"
import script from "./colorButton.vue?vue&type=script&lang=ts"
export * from "./colorButton.vue?vue&type=script&lang=ts"

import "./colorButton.vue?vue&type=style&index=0&id=5380ca4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5380ca4a"]])

export default __exports__